var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuspendYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 30,
    viewBox: "0 0 42 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16913_286251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.01 28.09C33.01 28.09 32.95 28.09 32.92 28.09C28.16 28.49 20.51 28.5 20.42 28.5C20.3 28.5 7.93 28.49 4.86 27.67C4.02 27.44 3.25 27.01 2.63 26.4C2.01 25.79 1.56 25.02 1.34 24.19C0.51 21.09 0.5 14.59 0.5 14.53C0.5 14.47 0.5 7.97 1.34 4.89C1.56 4.04 2.01 3.26 2.62 2.64C3.24 2.02 4.01 1.57 4.86 1.33C7.93 0.51 20.3 0.5 20.42 0.5C20.54 0.5 32.91 0.51 35.98 1.33C36.82 1.57 37.59 2.02 38.21 2.64C38.83 3.26 39.27 4.04 39.5 4.89C40.32 7.97 40.33 14.47 40.33 14.53C40.33 14.57 40.32 17.91 40.02 20.95V20.98",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7498 14.5296L16.3398 20.4496V8.59961L26.7498 14.5196V14.5296Z",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 29.5C39.26 29.5 41.5 27.26 41.5 24.5C41.5 21.74 39.26 19.5 36.5 19.5C33.74 19.5 31.5 21.74 31.5 24.5C31.5 27.26 33.74 29.5 36.5 29.5Z",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1898 20.8096L32.8198 28.1796",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16913_286251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspendYoutube);
export default __webpack_public_path__ + "static/media/suspendYoutube.99d68aced7d75c8d1010464578b50616.svg";
export { ForwardRef as ReactComponent };